import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const MeasurementsPage = lazy(async () => {
  const m = await import("@/features/gym/components/measurements-page");
  return { default: m.MeasurementsPage };
});

interface MeasurementsSearch {
  /** "New measurement" dialog open (`?new=1`) — copyable/shareable state. */
  new?: "1";
}

export const measurementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/measurements",
  validateSearch: (search: Record<string, unknown>): MeasurementsSearch =>
    // CC-18: also accepts the NUMBER 1. TanStack JSON-parses pasted `?new=1` as
    // number 1 (not string), and without this case the param was discarded at boot
    // and the deep-link dialog never opened.
    search.new === "1" || search.new === 1 ? { new: "1" } : {},
  component: () => (
    <Suspense fallback={null}>
      <MeasurementsPage />
    </Suspense>
  ),
});
